// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Wire enum for the server "RoleFlag" type (members + integer values are the
// wire contract). The hand facade in app/common re-exports this and hosts any
// non-derivable helpers; see design/wiki/wire-schemas.md.
export enum Role {
  None = 0,
  Advisor = 1,
  TeamLocaliser = 2,
  Retired_TeamAuthor = 3,
  TeamAdmin = 11,
  AdviceAdmin = 12,
  Tester = 21,
  Trial = 22,
  Compose = 23,
  Retired_Workspace = 24,
  DemoTeam = 90,
  SiteAdmin = 91,
  Master = 99,
}
